import {defineSlotRecipe} from '@chakra-ui/react3'
import {CONTENT_MOTION, inColumn, LEVEL_MOTION} from './flyout-stagger'

/**
 * Slot recipe for the shared level-3 breadcrumb.
 *
 * The breadcrumb is shared by the standard and teaser-only level-3 panes, so
 * its layout and motion belong here rather than in either pane recipe.
 */
export const flyoutNavigationLevel3BreadcrumbRecipe = defineSlotRecipe({
    className: 'flyout-navigation-level3-breadcrumb',
    slots: [
        'breadcrumb',
        'back',
        'backIcon',
        'backLabel',
        'breadcrumbDivider',
        'breadcrumbCurrent'
    ],
    base: {
        breadcrumb: {
            ...inColumn(0),
            ...CONTENT_MOTION,
            ...LEVEL_MOTION,
            display: 'flex',
            alignItems: 'center',
            gap: 'spacing-8',
            minWidth: 0
        },
        back: {
            display: 'flex',
            alignItems: 'center',
            gap: 'spacing-8',
            cursor: 'pointer',
            border: 'none',
            background: 'none',
            textAlign: 'start',
            padding: 0,
            minWidth: 0,
            color: 'text.secondary'
        },
        backIcon: {
            flexShrink: 0,
            _icon: {
                // Without an explicit size the chakra('svg') wrapper emits no
                // class and the reset collapses the SVG to zero dimensions.
                width: '1.5rem',
                height: '1.5rem'
            }
        },
        backLabel: {
            // Mobile names only the level the user is on; the category it was
            // reached from is desktop-only (STOK-17026 §3).
            display: {base: 'none', s: 'block'},
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            color: 'text.tertiary',
            textStyle: 'heading.medium'
        },
        breadcrumbDivider: {
            display: {base: 'none', s: 'block'},
            flexShrink: 0,
            color: 'text.tertiary',
            textStyle: 'heading.medium'
        },
        breadcrumbCurrent: {
            // The trailing crumb is always italic, at every viewport.
            color: 'text.primary',
            textStyle: 'heading.mediumItalic',
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            // Keeps italic glyphs from being clipped at the trailing edge.
            paddingRight: 'spacing-3'
        }
    }
})
